import { render } from "./notices.vue?vue&type=template&id=4b8c1c64&scoped=true"
import script from "./notices.vue?vue&type=script&lang=js"
export * from "./notices.vue?vue&type=script&lang=js"

import "./notices.vue?vue&type=style&index=0&id=4b8c1c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8c1c64"]])

export default __exports__